<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Update Admin Credentials</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <form [formGroup]="credentialsForm" autocomplete="off" spellcheck="false">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Enter Admin Username</mat-label>
        <input matInput placeholder="Enter Admin Username" formControlName='username'>
        <mat-error *ngIf="credentialsForm.get('username').touched && credentialsForm.get('username').errors?.required">Username Required*</mat-error>
        <mat-error *ngIf="credentialsForm.get('username').touched && credentialsForm.get('username').errors?.pattern">Username must contain minimum 3 letters</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Enter Admin Password</mat-label>
        <input matInput placeholder="Enter Admin Password" type="text" formControlName='password'>
        <mat-error *ngIf="credentialsForm.get('password').touched && credentialsForm.get('password').errors?.required">Password Required*</mat-error>
        <mat-error *ngIf="credentialsForm.get('password').touched && credentialsForm.get('password').errors?.pattern">Password must contain minimum 3 letters</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">Update</button>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default" zIndex = "1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="updateCredential"
    ><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
